import { Tooltip } from '@odo/shared-ui';
import { formatIamScope, type IamScope } from '../../../services/iam';
import { shortRoleKey } from '../iamLookups';
import { ScopeMeter } from './ScopeTag';
import { scopeMeterLevel, scopeMeterTone, scopeWrapClass } from './scopeColor';

// One grant at list density: colour/weight carry blast radius (ScopeTag's
// wrap classes), role title is the visible label, key/exact scope move into
// a hover Tooltip. Bundles show their key instead, styled italic.
interface GrantChipProps {
    roleKey: string;
    roleKind: 'role' | 'bundle';
    /** Null for bundles (no title) and for roles the catalog lookup couldn't resolve. */
    roleTitle: string | null;
    scope: IamScope;
    scopeLabel?: string | null;
    className?: string;
}

export function GrantChip({
    roleKey,
    roleKind,
    roleTitle,
    scope,
    scopeLabel,
    className = ''
}: GrantChipProps) {
    const isBundle = roleKind === 'bundle';
    const label = !isBundle && roleTitle ? roleTitle : shortRoleKey(roleKey);
    const level = scopeMeterLevel(scope.type);
    const tone = scopeMeterTone(scope.type);
    const wrap = scopeWrapClass(scope.type);
    const scopeDetail = scopeLabel
        ? `${scopeLabel} - ${formatIamScope(scope)}`
        : formatIamScope(scope);

    return (
        <Tooltip content={scopeDetail} side="top">
            <span
                className={`inline-flex items-center gap-1.5 rounded-lg px-2 py-1 max-w-full font-semibold whitespace-nowrap ${wrap} ${className}`.trim()}
            >
                <ScopeMeter level={level} tone={tone} />
                <span className={`text-[11px] truncate max-w-[150px] ${isBundle ? 'italic' : ''}`}>
                    {label}
                </span>
            </span>
        </Tooltip>
    );
}
